module.exports = __webpack_public_path__ + "media/images/flags/UG-e722eeb719b6bcdccb449f2e1fa3a04a.svg";